import { render, staticRenderFns } from "./PrizeListMain.vue?vue&type=template&id=781748df"
import script from "./PrizeListMain.vue?vue&type=script&lang=js"
export * from "./PrizeListMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports